import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { STATUS } from 'src/app/enums/status.enum';
import { SYSTEM } from 'src/app/enums/system.enum';
import { PurchaseItem } from 'src/app/models/purchase-item';
import { ApiService } from 'src/app/services/api.service';
import { LoadingService } from 'src/app/services/loading.service';
import { OrderSummaryServiceService } from 'src/app/services/order-summary-service.service';

@Component({
  selector: 'app-purchase-home',
  templateUrl: './purchase-home.component.html',
  styleUrls: ['./purchase-home.component.css']
})
export class PurchaseHomeComponent implements OnInit {
  passOfPurchase: any;

  constructor(
    private orderSummary: OrderSummaryServiceService,
    private apiService: ApiService,
    private loadingService: LoadingService
  ) { }

  ngOnInit(): void {
    this.orderSummary.update();
    this.loadingService._setLoading();
    this.getPassOfPurchases();
  }

  getPassOfPurchases() {
    this.apiService.getPassOfPurchase().subscribe(res => {
      try {
        if (res.status != STATUS.SUCCESS){
          return;
        }
        this.passOfPurchase= res.data;
        this.loadingService._clearLoading();
      } catch (error) {
        console.log("Error=>", error);
      }
    })
  }

}
